const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3001"

/** Resolve CMS image paths for display (static, Cloudinary, or API uploads). */
export const resolveImageUrl = (url?: string) => {
  if (!url) return ""
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith("/uploads")) return `${API_BASE_URL}${url}`
  return url
}

export const isImageUrl = (url?: string, mimeType?: string) => {
  if (mimeType?.startsWith("image/")) return true
  if (!url) return false
  return /\.(png|jpe?g|gif|webp|svg)$/i.test(url)
}
